import { format } from 'date-fns';
import React from 'react';
import { FaFacebook, FaGithub, FaLinkedin, FaTwitter, FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { IoCall, IoLocation, IoMail } from "react-icons/io5";

const Footer = () => {
    return (
        <div className='bg-indigo-900'>
            <div className=' text-white pt-10 max-w-[1400px] m-auto'>
                <div className='flex flex-col md:flex-row lg:flex-row justify-between px-5 md:px-20 lg:px-32 mb-2'>
                    <div className='mb-5'>
                        <h1 className='text-2xl font-bold opacity-80 text-teal-300'>Shakil Ahamed</h1>
                        <p className='font-bold opacity-70'>Web & App Developer</p>
                    </div>
                    <div className='mb-5'>
                        <h1 className='opacity-50 mb-4 font-bold text-sm'>Contact Address</h1>
                        <p className='flex items-center gap-1 text-xs font-bold opacity-80 mb-1'><IoCall></IoCall> +880 1794267010</p>
                        <p className='flex items-center gap-1 text-xs font-bold opacity-80 mb-1'><IoMail />web.shakil10@gmail.com</p>
                        <p className='flex items-center gap-1 text-xs font-bold opacity-80'><IoLocation></IoLocation> Dhanmondi, Dhaka, Bangladesh</p>
                    </div>
                    <div>
                        <h1 className='opacity-50 mb-4 font-bold text-sm'>Social Media</h1>
                        <div className='flex gap-4'>
                            <Link to='https://www.facebook.com/sakil2171' target='_blank' className='border rounded-full p-2 border-teal-300 text-xs hover:text-white text-teal-300'>
                                <FaFacebook></FaFacebook>
                            </Link>
                            <Link to='https://twitter.com/ShakilA42712830' target='_blank' className='border rounded-full p-2 border-teal-300 text-xs hover:text-white text-teal-300'>
                                <FaTwitter></FaTwitter>
                            </Link>
                            <Link to='https://wa.me/+8801794267010?text=Hello,' target='_blank' className='border rounded-full p-2 border-teal-300 text-xs hover:text-white text-teal-300'>
                                <FaWhatsapp></FaWhatsapp>
                            </Link>
                            <Link to='https://github.com/Sakil71' target='_blank' className='border rounded-full p-2 border-teal-300 text-xs hover:text-white text-teal-300'>
                                <FaGithub></FaGithub>
                            </Link>
                            <Link to='https://www.linkedin.com/in/shakil-ahamed-097164177/' target='_blank' className='border rounded-full p-2 border-teal-300 text-xs hover:text-white text-teal-300'>
                                <FaLinkedin></FaLinkedin>
                            </Link>
                        </div>
                    </div>
                </div>
                <p className=' text-center text-xs'>&copy;{format(new Date(), 'y')} - all right reserved</p>
            </div>
        </div>
    );
};

export default Footer;